import { IconButton } from "@material-ui/core"
import { AboutPath } from "../../../routes"
import Arrows from "../../../components/Icons/Arrows"
import Gallery2D from "../../../components/Gallery2D"
import { Holder, BackButton, Content } from "./Visionaries.style"
import VisionariesSlide1 from "./VisionariesSlide1"
import VisionariesSlide2 from "./VisionariesSlide2"
import VisionariesSlide3 from "./VisionariesSlide3"
import VisionariesSlide4 from "./VisionariesSlide4"
import VisionariesSlide5 from "./VisionariesSlide5"
import VisionariesSlide6 from "./VisionariesSlide6"

// const Colors = [
//   "#7B73F9",
//   "#A26ECB",
//   "#BDB2B5",
//   "#0072C3",
//   "#CF535F",
//   "#7B73F9",
//   "#A26ECB",
//   "#BDB2B5",
//   "#0072C3",
//   "#CF535F"
// ]

const items = [
  { id: 1, comp: <VisionariesSlide1 />, bgColor: "#7B73F9" },
  { id: 2, comp: <VisionariesSlide2 />, bgColor: "#A26ECB" },
  { id: 3, comp: <VisionariesSlide3 />, bgColor: "#BDB2B5" },
  { id: 4, comp: <VisionariesSlide4 />, bgColor: "#0072C3" },
  { id: 5, comp: <VisionariesSlide5 />, bgColor: "#CF535F" },
  { id: 6, comp: <VisionariesSlide6 />, bgColor: "#BDB2B5" }
]

function Visionaries() {
  return (
    <Holder>
      <Gallery2D
        items={items}
        width={Math.floor(window.screen.width * 0.7)}
        visible={3}
      >
        {({ id, comp }) => <Content key={id}>{comp}</Content>}
      </Gallery2D>
      <BackButton to={AboutPath}>
        <IconButton>
          <Arrows flip={1} />
        </IconButton>
      </BackButton>
    </Holder>
  )
}

export default Visionaries
